module.exports = __webpack_public_path__ + "static/media/26.4ae7bc77.mp3";